import React from "react";
import { formatNumber2 } from "../../../utils/currencyFormat";

const MiniCard = ({ title, value, iconClass, type, onClick, loading }) => (
  <div
    className="col text-center"
    style={{ cursor: "pointer" }}
    onClick={() => onClick(type, `Chi tiết ${title}`)}
  >
    <i className={`fas ${iconClass} fa-2x text-gray-400 mb-2`}></i>
    <div
      className="text-xs font-weight-bold text-uppercase mb-1 btn-link"
      style={{ color: "#00B69B" }}
    >
      {title}
    </div>
    {loading ? (
      <div className="spinner-border spinner-border-sm" role="status"></div>
    ) : (
      <div className="h6 mb-0 font-weight-bold text-gray-800">
        {formatNumber2(value)}
      </div>
    )}
  </div>
);

export const SummarySection = ({ data, loading, onItemClick, showPenalty }) => {
  const summaryItems = [
    {
      title: "Tổng Thu Gốc",
      value: data[0]?.TongThuGoc,
      type: "goc",
      icon: "fa-coins",
    },
    {
      title: "Tổng Thu Lãi",
      value: data[0]?.TongThuLai,
      type: "lai",
      icon: "fa-percent",
    },
    {
      title: "Tổng Thu Phí Hàng Kỳ",
      value: data[0]?.TongThuPhiHangKy,
      type: "phihangky",
      icon: "fa-file-invoice-dollar",
    },
    {
      title: "Tổng Thu Ngoài Lề",
      value: data[0]?.TongThuNgoaiLe,
      type: "ngoaile",
      icon: "fa-receipt",
    },
    {
      title: "Tổng Thu Khác",
      value: data[0]?.TongThuKhac,
      type: "khac",
      icon: "fa-box-open",
    },
  ];
  if (showPenalty) {
    summaryItems.push({
      title: "Phí Phạt",
      value: data[0]?.TongThuPhiPhat,
      type: "phiphat",
      icon: "fa-exclamation-triangle",
    });
  }
  return (
    <div className="p-2">
      <div className="text-center">
        <h6 className="text-uppercase text-muted">Tổng Thu</h6>
        {loading ? (
          <div className="spinner-border text-danger" role="status"></div>
        ) : (
          <h1 className="font-weight-bold" style={{ color: "#e74a3b" }}>
            {formatNumber2(data[0]?.TongThu)}
          </h1>
        )}
      </div>
      <hr />
      <div className="row">
        {summaryItems.map((item) => (
          <MiniCard
            key={item.type}
            title={item.title}
            value={item.value}
            type={item.type}
            onClick={onItemClick}
            loading={loading}
            iconClass={item.icon}
          />
        ))}
      </div>
    </div>
  );
};
